export const mapTranslations = {
  en: {
    filterCountry: "FILTER BY COUNTRY:",
    filterRegion: "Filter by region:",
    filterField: "Filter by field:",
    filterProvince: "FILTER BY PROVINCE/CITY:",
    selectProvince: "Select province/city",
    allProvinces: "All provinces/cities",
    filterFieldSection: "FILTER BY FIELD:",
    filterProjectBtn: "Project Filter",
    north: "North",
    central: "Central",
    south: "South",
    mekong: "Mekong Delta",
    apply: "Apply",
    reset: "Reset",
    list: "List",
    filter: "Filter",
    searchPlaceholder: "Which project are you looking for?",
    closeMap: "Close map",
    zoomIn: "Zoom in",
    zoomOut: "Zoom out",
    roadmap: "Standard",
    satellite: "Satellite",
    terrain: "Terrain",
    provinceMode34: "34 Provinces & Cities",
    provinceMode63: "63 Provinces & Cities",
    currentLocation: "Current Location",
    routeView: "Route",
    totalDistanceLabel: "Distance",
    totalDurationLabel: "Duration",
    stepsTitle: "Directions",
    mapNotReady: "Digitized Map Not Ready",
    mapUnderDevelopment: "Map feature is under development. Please check back later.",
    inDevelopment: "In Development",
    projectListTitle: "PROJECT LIST SUMMARY",
    explore360: "Explore 360",
    getDirections: "Directions",
    noThumbnail: "No thumbnail available",
    countryNames: {
      "all": "All countries",
      "vietnam": "Vietnam",
      "usa": "United States",
      "canada": "Canada",
      "australia": "Australia",
      "abroad": "Abroad"
    },
    fields: {
      "tourism": "Tourism",
      "heritage": "Heritage",
      "museum": "Museum",
      "city": "City",
      "oil-and-gas": "Oil & Gas",
      "factory": "Factory",
      "zone": "Industrial Park",
      "facility": "Infrastructure",
      "showroom": "Showroom",
      "real-estate": "Real Estate",
      "exhibition": "Exhibition",
      "office": "Office",
      "school": "School",
      "farm": "Farm"
    }
  },
  vn: {
    filterCountry: "LỌC THEO QUỐC GIA:",
    filterRegion: "Lọc theo vùng miền:",
    filterField: "Lọc theo lĩnh vực:",
    filterProvince: "LỌC THEO TỈNH THÀNH:",
    selectProvince: "Chọn tỉnh thành",
    allProvinces: "Tất cả tỉnh thành",
    filterFieldSection: "LỌC THEO LĨNH VỰC:",
    filterProjectBtn: "Bộ lọc dự án",
    north: "Miền Bắc",
    central: "Miền Trung",
    south: "Miền Nam",
    mekong: "ĐB. Sông Cửu Long",
    apply: "Áp dụng",
    reset: "Đặt lại",
    list: "Danh sách",
    filter: "Bộ lọc",
    searchPlaceholder: "Bạn cần tìm dự án nào?",
    closeMap: "Đóng bản đồ",
    zoomIn: "Phóng to",
    zoomOut: "Thu nhỏ",
    roadmap: "Bản đồ",
    satellite: "Vệ tinh",
    terrain: "Địa hình",
    provinceMode34: "34 Tỉnh Thành",
    provinceMode63: "63 Tỉnh Thành",
    currentLocation: "Vị trí hiện tại",
    routeView: "Đường đi",
    totalDistanceLabel: "Quãng đường",
    totalDurationLabel: "Thời gian",
    stepsTitle: "Hướng dẫn",
    mapNotReady: "Bản đồ số hóa chưa sẵn sàng",
    mapUnderDevelopment: "Tính năng bản đồ đang được phát triển. Vui lòng quay lại sau.",
    inDevelopment: "Đang phát triển",
    projectListTitle: "TỔNG HỢP DANH SÁCH DỰ ÁN",
    explore360: "Khám phá 360",
    getDirections: "Chỉ đường",
    noThumbnail: "Không có ảnh đại diện",
    countryNames: {
      "all": "Tất cả quốc gia",
      "vietnam": "Việt Nam",
      "usa": "Mỹ",
      "canada": "Canada",
      "australia": "Úc",
      "abroad": "Nước ngoài"
    },
    fields: {
      "tourism": "Du lịch",
      "heritage": "Di sản",
      "museum": "Bảo tàng",
      "city": "Thành phố",
      "oil-and-gas": "Dầu khí",
      "factory": "Nhà máy",
      "zone": "KCN",
      "facility": "Hạ tầng",
      "showroom": "Showroom",
      "real-estate": "Bất động sản",
      "exhibition": "Triển lãm",
      "office": "Văn phòng",
      "school": "Trường học",
      "farm": "Trang trại"
    }
  },
  ja: {
    filterCountry: "国でフィルター:",
    filterRegion: "地域でフィルター:",
    filterField: "分野でフィルター:",
    filterProvince: "省・市でフィルター:",
    selectProvince: "省・市を選択",
    allProvinces: "すべての省・市",
    filterFieldSection: "分野でフィルター:",
    filterProjectBtn: "プロジェクトフィルター",
    north: "北部",
    central: "中部",
    south: "南部",
    mekong: "メコンデルタ",
    apply: "適用",
    reset: "リセット",
    list: "リスト",
    filter: "フィルター",
    searchPlaceholder: "どのプロジェクトをお探しですか？",
    closeMap: "地図を閉じる",
    zoomIn: "拡大",
    zoomOut: "縮小",
    roadmap: "地図",
    satellite: "衛星写真",
    terrain: "地形",
    provinceMode34: "34省・市",
    provinceMode63: "63省・市",
    currentLocation: "現在地",
    routeView: "ルート",
    totalDistanceLabel: "距離",
    totalDurationLabel: "所要時間",
    stepsTitle: "道順",
    mapNotReady: "デジタル化マップの準備ができていません",
    mapUnderDevelopment: "マップ機能は開発中です。後ほどもう一度ご確認ください。",
    inDevelopment: "開発中",
    projectListTitle: "プロジェクトリスト概要",
    explore360: "360度ツアーを体験",
    getDirections: "ルート案内",
    noThumbnail: "サムネイルがありません",
    countryNames: {
      "all": "すべての国",
      "vietnam": "ベトナム",
      "usa": "アメリカ",
      "canada": "カナダ",
      "australia": "オーストラリア",
      "abroad": "海外"
    },
    fields: {
      "tourism": "観光",
      "heritage": "遺産",
      "museum": "博物館・美術館",
      "city": "都市",
      "oil-and-gas": "石油・ガス",
      "factory": "工場",
      "zone": "工業団地",
      "facility": "インフラ",
      "showroom": "ショールーム",
      "real-estate": "不動産",
      "exhibition": "展示会",
      "office": "オフィス",
      "school": "学校",
      "farm": "農場"
    }
  }
};
